import { WelcomePageForm } from "@datagame/ui";

import { GameKind, WelcomePage } from "../../gql/graphql";
import { Transition } from "../shared/Transition";
import { CustomizedBackground } from "../CustomizedBackground";

import styles from "./WelcomeScreen.module.scss";
import { useMemo } from "react";
import { GLAUKOS_PROJECT_ID_PRODUCTION, GLAUKOS_PROJECT_ID_STAGING } from "../../main";

export interface WelcomePageProps {
  config: WelcomePage;
  gameKind: GameKind;
  theme: string;
  onClick: () => void;
  isQuickPickGame?: boolean;
  hideDatagameBranding?: boolean;
}

export const WelcomeScreen = (props: WelcomePageProps) => {
  const { config, gameKind, theme, onClick, hideDatagameBranding, isQuickPickGame = false } = props;

  const isGlaukosProject =
    window.location.pathname.includes(GLAUKOS_PROJECT_ID_PRODUCTION) ||
    window.location.pathname.includes(GLAUKOS_PROJECT_ID_STAGING);

  return (
    <Transition>
      <CustomizedBackground config={config}>
        <div className={styles.wrapper}>
          <WelcomePageForm
            config={config}
            gameKind={gameKind}
            onClick={onClick}
            isQuickPickGame={isQuickPickGame}
            theme={theme}
            hideDatagameBranding={hideDatagameBranding}
            isGlaukosProject={isGlaukosProject}
          />
        </div>
      </CustomizedBackground>
    </Transition>
  );
};
